<script>
    export let path = '';
    let branchPath = '';
    let branches = path.split('/').reverse();

    $: if (path) {
        branches = path.split('/').reverse();
        branchPath = formatPath();
    }

    

    function formatPath() {
        if(path[0] === '/'){
            path = path.substring(1);
        }
        
        let formated = '';
        let caret = branches.length > 1 ? ' < ' : '';

        branches.forEach((b, i) => {
            caret = i === 1 ? '' : ' < ';
            if(i > 0 && b){
                formated += caret + b;
            }
                        
        });

        return formated;
    }
</script>

<style>
    .branches {
        font-size: 12px;
    }
</style>

<div>
    <div class="leaf">{branches[0]}</div>
    <div class="branches">{branchPath}</div>
</div>